// Screen ids come from the backend `screens` list in GET /auth/me.
export const SCREEN_PATHS = {
  dashboard: "/dashboard",
  sender_warehouse: "/sender-warehouse",
  planning: "/planning",
  receiver_warehouse: "/receiver-warehouse",
  marketplace_amazon_fba: "/marketplace/amazon-fba",
  admin: "/admin",
};

const LANDING_ORDER = ["sender_warehouse", "planning", "receiver_warehouse", "marketplace_amazon_fba", "admin", "dashboard"];

export function hasScreen(user, screen) {
  return Boolean(user?.screens?.includes(screen));
}

export function landingPath(user) {
  const screen = LANDING_ORDER.find(s => hasScreen(user, s));
  return screen ? SCREEN_PATHS[screen] : "/dashboard";
}

export function roleBadgeKey(role) {
  if (role === "TOOLS_USER") return "role.platform_admin";
  if (role === "TENANT_ADMIN") return "role.tenant_admin";
  if (role === "TENANT_MEMBER") return "role.tenant_member";
  return "role.warehouse_staff";
}
